import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddDeviceState, addDeviceFeatureKey } from './add-device.reducer';

const getAddDeviceFeature = createFeatureSelector<AddDeviceState>(addDeviceFeatureKey);

export const getAddDeviceCallState = createSelector(getAddDeviceFeature, (state) => {
   return state.callState;
});

export const getDeviceTypeFromStore = createSelector(getAddDeviceFeature, (state) => state.deviceType);

export const getMostRecentAccount = createSelector(getAddDeviceFeature, (state) => ({
   accountId: state.accountId,
   name: state.accountName,
}));
